<template>

  <w-flex wrap class="text-center basis-zero">
    <br />
    <div class="xs2 pa2">
      <w-card title="Search" title-class="primary-dark1--bg">
        <w-form @submit.prevent="search()">
          <w-input class="mxa" label="Model Search" v-model="newSearch" name="newSearch" inner-icon-left="wi-search"
            label-position="inside" outline="outline"></w-input>
          <w-button bg-color="warning" type="submit">Search</w-button>
        </w-form>
        <w-form @submit.prevent="searchPN()">
          <w-input class="mt6 mb2" label="Spare Part Search" v-model="SparePartSearch" name="newSearch"
            inner-icon-left="wi-search" label-position="inside" outline="outline"></w-input>
          <w-button bg-color="warning" type="submit">Search</w-button>
        </w-form>
        <template #actions>
          <div class="spacer"></div>
          <!-- <w-button bg-color="error" class="mr2">
            <w-icon class="mr1">wi-cross</w-icon>Clear
          </w-button>
          <w-button bg-color="success">
            <w-icon class="mr1">wi-search</w-icon>Find
          </w-button>-->
        </template>
      </w-card>

      <div class="pt2">
        <w-card title="Device Details" title-class="primary-dark1--bg">
          <w-table style="margin: auto;" :headers="lookingat.headers" :items="lookingat.items"
            :mobile-breakpoint="1280">
            <template #no-data>👌 There is no data! 👌</template>
          </w-table>
        </w-card>
      </div>
      <div class="pt2">
        <w-card title="Exploded Views" title-class="primary-dark1--bg">
          <table style="margin: auto;">
            <thead class="thead-dark">
              <!-- <th>Files</th> -->
            </thead>
            <tbody>
              <tr v-for="file in files" :key="file.thumbnailurl">
                <td>
                  <img class="file" :src="file.thumbnailurl" @click="openfile(file.url)" />
                </td>
              </tr>
            </tbody>
          </table>
        </w-card>
      </div>
    </div>

    <!-- <h2>Searching for : {{newSearch||SparePartSearch}}</h2> -->
    <!-- <h1>ID:{{articleNo}}</h1> -->
    <!-- <form @submit.prevent="searchPartNumber()">
      <label>Part Search</label>
      <input v-model="newPartSearch" name="newSearch" />
      <button>Search</button>
    </form>-->

    <div class="xs9 pa2">
      <w-card title="Results" title-class="primary-dark1--bg">
        <w-accordion :items="1" v-model="PartsTable.accordion">
          <template #item-title>Parts {{ PartsTable.items.length }}</template>

          <template #item-content>
            <w-flex justify-center class="pa2">
              <w-input inner-icon-left="wi-search" label-position="inside" outline="outline" label="Part Search "
                v-model="PartSearch" />
              <w-input inner-icon-left="wi-search" label-position="inside" outline="outline" label="Pos No "
                v-model="PosLookup" />
              <w-button icon="mdi mdi-filter" text lg class="ml3" bg-color="warning" outline
                @click="FilterButton()"></w-button>
            </w-flex>
            <w-table :headers="PartsTable.headers" :items="PartsTable.items" :mobile-breakpoint="1280"
              :loading="PartsTable.loading" :sort="PartsTable.sort" :filter="PartsTable.filter"
              :selectable-rows="PartsTable.selectableRows" @row-select="getPartDetails($event.item)">
              <template #no-data>👌 There is no data! 👌</template>

              <template #item-cell="{ item, label, header }">
                <div v-if="header.label == 'ID'">
                  <img :src="item.Artikelthumbnail" />
                </div>

                <!-- <div
                  v-if="item.Lieferzeit !='Voraussichtlich lieferbar innerhalb von 1 - 2 Wochen'"
                >Expected to be available within 1 - 2 weeks</div>
                <div
                  v-if="item.Lieferzeit =='Voraussichtlich lieferbar innerhalb von 4 - 5 Wochen'"
                >Expected to be available within 4 - 5 weeks</div>-->

                <div :style="item.style">{{ label }}</div>
              </template>
            </w-table>
          </template>
        </w-accordion>

        <w-accordion :items="1" v-model="Devices.accordion">
          <template #item-title>Models {{ Devices.items.length }}</template>

          <template #item-content>
            <w-table :headers="Devices.headers" :items="Devices.items" :loading="Devices.loading"
              :mobile-breakpoint="1280" :selectable-rows="true" :sort="Devices.sort" select-row="select-row"
              @row-select="selectionInfo = $event">
              <!-- @row-select="searchDeviceArticle(filterByCodeOrType(Devices.items,$event.item))" -->
              <!-- @row-select="searchDeviceArticle([$event.item,Devices.items.filter(it=>{if (it.suppliers !== $event.item.suppliers && (it.Type == $event.item.Type.trim() && it.Identnummer == $event.item.Identnummer)) return it})])" -->

              <template #no-data>👌 There is no data! 👌</template>
            </w-table>
          </template>
        </w-accordion>
        <w-button bg-color="warning" @click="getALLParts(selectionInfo.selectedRows)">Search Selected</w-button>
      </w-card>
    </div>
    <w-dialog v-model="dialog.show" :fullscreen="dialog.fullscreen" :width="dialog.width"
      :persistent="dialog.persistent" :persistent-no-animation="dialog.persistentNoAnimation"
      title-class="primary-light1--bg white">
      <template #title>
        <w-icon class="mr2">mdi mdi-tune</w-icon>View File
      </template>
      <iframe height="100%" width="100%" style="border:none;" :src="fileurl"></iframe>

      <template #actions>
        <div class="spacer" />
        <w-button bg-color="warning" @click="dialog.show = false">Close</w-button>
      </template>
    </w-dialog>
  </w-flex>
</template>

<script>
// VUE_APP_PROXY= https://t1h2h0-cors.herokuapp.com/http://aswoshop.aswo.com
//VUE_APP_PROXY= https://cors-anywhere.herokuapp.com/http://aswoshop.aswo.com

import { ref } from "vue";
import axios from "axios";
// import json from "../assets/allparts.json";
// import djson from "../assets/allDParts.json";
import router from "../router"
import { usePartStore } from '../store/part'
import { getSeviceNetParts, getAltParts } from "./Wrapper.js";
const ConnectProvider = { code: "1100001235", name: "Connect" }; //Connect
const ASWOProvider = { code: "1100757010", name: "ASWO" }; //ASWO
// import { useUserStore } from "../store/user";
// const { user } = useUserStore().fetchUser()
// console.log(user);
// let suppliers = ASWOProvider.code;

export default {
  mounted() {
    document.getElementById("aswo").addEventListener("click", event => {
      const place = event.srcElement;
      document.getElementById("connect").style.border =
        "0px solid rgb(245, 220, 225)";

      // suppliers = ASWOProvider.code;
      place.style.border = "4px solid rgb(245, 220, 225)";
    });
    document.getElementById("connect").addEventListener("click", event => {
      const place = event.srcElement;
      document.getElementById("aswo").style.border =
        "0px solid rgb(245, 220, 225)";
      // suppliers = ConnectProvider.code;
      place.style.border = "4px solid rgb(245, 220, 225)";
    });
  },

  setup() {
    const dialog = ref({
      show: false,
      fullscreen: true,
      persistent: false,
      persistentNoAnimation: false,
      width: 800,
      height: 800
    });

    const newPartSearch = ref("");
    const newSearch = ref("");
    const SparePartSearch = ref("");
    const PartSearch = ref("");
    const StockCheck = ref("In Stock");
    const DeliveryTime = ref(100);
    const Obsolete = ref(-1);
    const PosLookup = ref("");
    const ArticleSearch = ref("");
    const DeviceArticleSearch = ref("");
    const DeviceFilesSearch = ref("");
    const fileurl = ref("");

    let PartsTable = ref({
      headers: [
        { label: "Supplier", key: "suppliername", align: "center" },
        { label: "ID", key: "Artikelnummer", align: "center" },
        { label: "Brand/Family	", key: "Hersteller", align: "center" },
        { label: "Code", key: "Originalnummer", align: "center" },
        { label: "Description", key: "Artikelbezeichnung", align: "center" },
        { label: " Price ", key: "Bruttopreis", align: "center" },
        { label: " Unit Price ", key: "Stueckpreis ", align: "center" },

        { label: "Status", key: "Lieferzeit", align: "center" },
        { label: "Alternative", key: "Alternative", align: "center" }
        // { label: "Pos No", key: "positionsnummern", align: "center" }
      ],
      items: [],
      selectableRows: true,
      selectionInfo: {},
      loading: false,
      accordion: [false],
      sort: "+Artikelbezeichnung",
      filter: item =>
        item.Artikelbezeichnung.toUpperCase().includes(
          PartSearch.value.toUpperCase()
        ) &&
        item.positionsnummern.includes(PosLookup.value.toUpperCase())
      // &&
      // item.Lieferzeit.includes(StockCheck.value) &&
      // item.deliverytimedays <= DeliveryTime.value &&
      // item.deliverytimedays != Obsolete.value
    });

    let articleNo = ref({});
    let Devices = ref({
      headers: [
        { label: "Supplier", key: `suppliername`, align: "center" },
        { label: "Brand	", key: "Hersteller", align: "center" },
        { label: "Family", key: "Geraeteart", align: "center" },

        { label: "Model", key: "Type", align: "center" },
        { label: "Code", key: "Identnummer", align: "center" },
        { label: "Number Of Parts", key: "Artikelanzahl", align: "center" }
      ],
      items: [],
      loading: false,
      accordion: [false],
      sort: "-Identnummer"
    });
    let files = ref({});
    let lookingat = ref({
      headers: [
        { label: "Supplier", key: "suppliername", align: "center" },
        { label: "Brand	", key: "Hersteller", align: "center" },
        { label: "Family", key: "Geraeteart", align: "center" },

        { label: "Model", key: "Type", align: "center" },
        { label: "Code", key: "Identnummer", align: "center" },
        { label: "Number Of Parts", key: "Artikelanzahl", align: "center" }
      ],
      items: []
    });
    const allparts = {}
    // Object.assign({}, json.Parts, djson.DParts);
    // console.log(articleNo.value.proxy);
    // console.log(
    //   // process.env.VUE_APP_PROXY + "/service/customerapi/devicesearch"
    //   process.env.VUE_APP_PROXY + "devicesearch"
    // );
    // console.log(
    //   // process.env.VUE_APP_PROXY + "/service/customerapi/devicesearch"
    //   JSON.stringify(process.env) + "ALL"
    // );
    // console.log(
    //   // process.env.VUE_APP_PROXY + "/service/customerapi/devicesearch"
    //   process.env.VUE_APP_ASWO_PROXY + "ASWO"
    // ); console.log(
    //   // process.env.VUE_APP_PROXY + "/service/customerapi/devicesearch"
    //   process.env.VUE_APP_CONNECT_PROXY + "CONNECT"
    // );
    function searchPartNumber() {
      const newlist = Object.values(this.articleNo).filter(parts => {
        return parts.Artikelbezeichnung >= this.newPartSearch.toUpperCase();
      });
      this.articleNo = newlist;
    }

    function FilterButton() {
      // if (StockCheck.value == "In Stock") {
      //   StockCheck.value = "";
      // } else {
      //   StockCheck.value = "In Stock";
      // }
      if (DeliveryTime.value == 100) {
        DeliveryTime.value = 7;
      } else {
        DeliveryTime.value = 100;
      }
      // console.log("FilterButton", JSON.parse(newlist));
    }
    function filterByCodeOrType(items, itemSelected) {
      console.log(itemSelected.Identnummer.substr(2, 5));

      var itemsByCode = items.filter(it => {
        if (
          (it.Identnummer == itemSelected.Identnummer &&
            itemSelected.Identnummer !== "") ||
          (it.Identnummer == itemSelected.Identnummer &&
            itemSelected.Identnummer !== "" &&
            it.Identnummer.includes(itemSelected.Identnummer.substr(2, 5)))
        ) {
          return it;
        }
      });
      var itemsByType = items.filter(it => {
        var typeIdentMatch =
          it.Type.replace(/\s/g, "") == itemSelected.Type.replace(/\s/g, "") &&
          it.Identnummer == itemSelected.Identnummer;
        var typeIdentemptyMatch =
          it.Type.replace(/\s/g, "") == itemSelected.Type.replace(/\s/g, "") &&
          it.Identnummer == itemSelected.Identnummer &&
          it.Identnummer &&
          itemSelected.Identnummer == "";

        var typeidentnotemptycontianscodeMatch =
          //may not need type ???
          it.Type.replace(/\s/g, "") === itemSelected.Type.replace(/\s/g, "") &&
          it.Identnummer !== itemSelected.Identnummer &&
          // it.Identnummer != "" &&
          // it.Identnummer.includes(itemSelected.Identnummer.substr(2, 5)) &&
          itemSelected.Identnumber !== "" &&
          it.Identnummer.includes(itemSelected.Identnummer.substring(2, 3));
        // if (
        //   typeIdentMatch ||
        //   typeIdentemptyMatch ||
        //   identnotemptycontianscodeMatch
        // ) {
        console.log(
          `TypeIdentMatch : ${typeIdentMatch} \n TypeIdentemptyMatch : ${typeIdentemptyMatch} \n TypeidentnotemptycontianscodeMatch : ${typeidentnotemptycontianscodeMatch}`
        );
        console.log(
          it.Identnummer + +itemSelected.Identnummer,
          itemSelected.Identnumber !== "" &&
          it.Identnummer.includes(itemSelected.Identnummer.substring(2, 3))
        );
        //   return it;
        // }
        if (typeIdentMatch) {
          return it;
        } else if (typeIdentemptyMatch) {
          return it;
        } else if (typeidentnotemptycontianscodeMatch) {
          return it;
        }
      });
      if (itemsByCode.length > 1) {
        console.log("Filter By  Code");
        return itemsByCode;
      } else {
        console.log("Filter By Type");
        return itemsByType;
      }
    }
    function search() {
      this.articleNo = null;
      this.Devices.items = [];
      this.files = null;
      this.PartsTable.items = [];
      this.PartsTable.accordion = [false];
      this.Devices.accordion = [true];
      this.Devices.loading = true;

      const suppliers = [ConnectProvider, ASWOProvider];
      suppliers.forEach(supplier => {
        getProducts(newSearch, supplier).then(response => {
          console.log(response.data);
          Object.keys(response.data).forEach(devices => {
            response.data[devices].suppliername = supplier.name;
            response.data[devices].supplier = supplier;
            this.Devices.items.push(response.data[devices]);
          });
          this.Devices.loading = false;
        });
      });
    }
    async function getProducts(newSearch, supplier) {
      const url = process.env.VUE_APP_PROXY + "devicesearch";
      return await axios.get(url, {
        withCredentials: false,

        auth: {
          username: "Tecnico",
          password: "Master"
        },
        headers: {
          "Content-type": "Application/json"
        },

        params: {
          devicesearchkeywords: newSearch.value,
          format: "JSON",
          apikey: "509-10350-6da36b49ef06ce650b8daa6edfe881de",
          providerid: supplier.code
        }
      });
    }

    function searchPN() {
      this.articleNo = null;
      this.Devices.items = [];
      this.lookingat.items = [];
      this.files = null;
      this.Devices.accordion = [false];
      this.PartsTable.items = [];
      this.PartsTable.accordion = [true];
      this.PartsTable.loading = true;
      const url =
        // process.env.VUE_APP_PROXY + "/service/customerapi/articlesearch";
        process.env.VUE_APP_PROXY + "articlesearch";

      // const DNumberSite =
      //   "https://us-central1-whirlpool-multibrand.cloudfunctions.net/webApi/api/v1/part/";
      // const SiteKey = "VlRGb1UxUlhTWGxhU0VKcFdub3dPUT09";
      // this.lookingat.item.push(SparePartSearch.value);
      const suppliers = [ASWOProvider, ConnectProvider];
      suppliers.forEach(supplier => {
        axios
          .get(url, {
            crossDomain: true,
            withCredentials: false,
            // origin: true,
            auth: {
              username: "Tecnico",
              password: "Master"
            },
            headers: {
              "postman-token": "513705db-790d-ead9-bab6-7f1b682583c6",
              "cache-control": "no-cache",
              // "Access-Control-Allow-Origin": "*",
              "Content-type": "Application/json"
              // Authorization: "Basic VGVjbmljbzpNYXN0ZXI="
            },
            params: {
              articlesearchkeywords: SparePartSearch.value,
              format: "JSON",
              apikey: "509-10350-6da36b49ef06ce650b8daa6edfe881de",
              providerid: supplier.code
            }
          })
          .then(response => {
            console.log(response.data);
            this.articleNo = response.data;
            this.PartsTable.loading = false;
            Object.keys(response.data).forEach(item => {
              this.PartsTable.items.push(response.data[item]);
              // console.log(response.data[item].Artikelnummer);
              console.log(response.data[item].Lieferzeit);
              response.data[item].positionsnummern = "";
              response.data[item].Alternative = "None";
              response.data[item].style = {};
              Object.keys(allparts).forEach(part => {
                response.data[item].supplier = supplier;
                response.data[item].suppliername = supplier.name;
                if (
                  allparts[part].partnumber ===
                  response.data[item].Artikelnummer
                ) {
                  response.data[item].Alternative = allparts[part].alternative;
                  if (allparts[part].alternative.startsWith("D")) {
                    response.data[item].style = {
                      "background-color": "lightblue"
                    };
                  }
                  if (allparts[part].alternative.startsWith("C")) {
                    response.data[item].style = {
                      "background-color": "orange"
                    };
                  }
                  // console.log(allparts[part].alternative);
                }
              });
            });
            // axios
            //   .get(DNumberSite + response.data[item].Artikelnummer, {
            //     headers: { authorization: SiteKey }
            //   })
            //   .then(parts => {
            //     const partskeys = Object.keys(parts.data);
            //     console.log(partskeys);
            //     partskeys.forEach(part => {
            //       console.log(parts.data[part].alternative);
            //       response.data[item].Alternative =
            //         parts.data[part].alternative;
            //     });
            //   });
          });
        this.PartsTable.loading = false;
      });
    }
    function searchArticle() {
      const url =
        // process.env.VUE_APP_PROXY + "/service/customerapi/articledata";
        process.env.VUE_APP_PROXY + "articledata";

      axios
        .get(url, {
          // crossDomain: true,
          withCredentials: false,
          // origin: true,
          auth: {
            username: "Tecnico",
            password: "Master"
          },
          headers: {
            "postman-token": "513705db-790d-ead9-bab6-7f1b682583c6",
            "cache-control": "no-cache",
            // "Access-Control-Allow-Origin": "*",
            "Content-type": "Application/json"
            // Authorization: "Basic VGVjbmljbzpNYXN0ZXI="
          },
          params: {
            artnr: ArticleSearch.value,
            format: "JSON",
            apikey: "509-10350-6da36b49ef06ce650b8daa6edfe881de"
          }
        })
        .then(response => {
          console.log(response.data);
          this.articleNo = response.data;

          this.PartsTable.items.push(response.data);
        });
    }
    function searchArticleReplacment() {
      const url =
        // process.env.VUE_APP_PROXY + "/service/customerapi/articlereplacment";
        process.env.VUE_APP_PROXY + "articlereplacment";
      const suppliers = [ASWOProvider, ConnectProvider];
      suppliers.forEach(supplier => {
        axios
          .get(url, {
            // crossDomain: true,
            withCredentials: false,
            // origin: true,
            auth: {
              username: "Tecnico",
              password: "Master"
            },
            headers: {
              "postman-token": "513705db-790d-ead9-bab6-7f1b682583c6",
              "cache-control": "no-cache",
              // "Access-Control-Allow-Origin": "*",
              "Content-type": "Application/json"
              // Authorization: "Basic VGVjbmljbzpNYXN0ZXI="
            },
            params: {
              artnr: ArticleSearch.value,
              format: "JSON",
              apikey: "509-10350-6da36b49ef06ce650b8daa6edfe881de",
              providerid: supplier.code
            }
          })
          .then(response => {
            console.log(response.data);
            this.articleNo = response.data;
          });
      });
    }

    async function getALLParts(listOfPoducts) {
      this.PartsTable.items = [];
      this.lookingat.items = [];
      this.PartsTable.accordion = [true];
      this.PartsTable.loading = true;

      listOfPoducts.forEach(async Item => {
        await getSeviceNetParts(Item)
          .then(response => {
            console.log("Item", response.data);
            this.articleNo = response.data;

            Object.keys(response.data).forEach(item => {
              response.data[item].supplier = Item.supplier;
              response.data[item].suppliername = Item.supplier.name;
              this.PartsTable.items.push(response.data[item]);
              // console.log(response.data[item].Artikelnummer);
              response.data[item].positionsnummern = response.data[item]
                .positionsnummern
                ? response.data[item].positionsnummern.join(" ")
                : "";
              response.data[item].Alternative = "None";
              response.data[item].style = {};
              Object.keys(allparts).forEach(part => {
                if (
                  allparts[part].partnumber ===
                  response.data[item].Artikelnummer
                ) {
                  response.data[item].Alternative = allparts[part].alternative;
                  if (allparts[part].alternative.startsWith("D")) {
                    response.data[item].style = {
                      "background-color": "lightblue"
                    };
                  }
                  if (allparts[part].alternative.startsWith("C")) {
                    response.data[item].style = {
                      "background-color": "orange"
                    };
                  }
                }
              });
            });
          })
          .catch(e => {
            console.log(e);
          });

        this.lookingat.items.push(Item);
        searchDeviceFiles(Item)
          .then((response, reason) => {
            console.log(response.data);
            console.log(reason);
            this.files = response.data.files;
          })
          .catch(e => {
            console.log(e);
          });
        if (this.lookingat.items.length == listOfPoducts.length) {
          this.PartsTable.loading = false;
        }
      });
    }

    function searchDeviceArticle(deviceIds) {
      console.log("Clicked Device Search");
      this.PartsTable.items = [];
      this.lookingat.items = [];
      this.PartsTable.accordion = [true];
      this.PartsTable.loading = true;
      console.log("IDS : ", deviceIds);

      deviceIds.forEach(Item => {
        console.log("IDS : ", Item);
        if (Item == null) {
          return;
        }
        this.lookingat.items.push(Item);

        // console.log(this.Devices.items);

        const url =
          // process.env.VUE_APP_PROXY + "/service/customerapi/devicearticles";

          process.env.VUE_APP_PROXY + "devicearticles";

        axios
          .get(url, {
            // crossDomain: true,
            withCredentials: false,
            // origin: true,

            auth: {
              username: "Tecnico",
              password: "Master"
            },
            headers: {
              "postman-token": "513705db-790d-ead9-bab6-7f1b682583c6",
              "cache-control": "no-cache",
              // "Access-Control-Allow-Origin": "*",
              "Content-type": "Application/json"
              // Authorization: "Basic VGVjbmljbzpNYXN0ZXI="
            },
            params: {
              deviceid: Item.Geraeteid,
              format: "JSON",
              apikey: "509-10350-6da36b49ef06ce650b8daa6edfe881de",
              providerid: Item.supplier.code,
              articlesearchterm: " "
            }
          })
          .then(response => {
            console.log(response.data);
            this.articleNo = response.data;
            this.PartsTable.loading = !this.PartsTable.loading;
            Object.keys(response.data).forEach(item => {
              response.data[item].supplier = Item.supplier;
              response.data[item].suppliername = Item.supplier.name;
              this.PartsTable.items.push(response.data[item]);
              // console.log(response.data[item].Artikelnummer);
              response.data[item].positionsnummern = response.data[item]
                .positionsnummern
                ? response.data[item].positionsnummern.join(" ")
                : "";
              response.data[item].Alternative = "None";
              response.data[item].style = {};
              Object.keys(allparts).forEach(part => {
                if (
                  allparts[part].partnumber ===
                  response.data[item].Artikelnummer
                ) {
                  response.data[item].Alternative = allparts[part].alternative;
                  if (allparts[part].alternative.startsWith("D")) {
                    response.data[item].style = {
                      "background-color": "lightblue"
                    };
                  }
                  if (allparts[part].alternative.startsWith("C")) {
                    response.data[item].style = {
                      "background-color": "orange"
                    };
                  }
                  // console.log(allparts[part].alternative);
                }
              });
            });
            this.PartsTable.loading = !this.PartsTable.loading;
            searchDeviceFiles(Item)
              .then(response => {
                console.log(response.data);
                if (response != undefined) {
                  this.files = response.data.files;
                }
              })
              .catch(e => {
                console.log(e);
              });
          });
      });
    }
    async function searchDeviceFiles(deviceId) {
      const url =
        // "http://aswoshop.aswo.com/service/customerapi/devicefiles";
        // process.env.VUE_APP_PROXY + "/service/customerapi/devicefiles";

        process.env.VUE_APP_PROXY + "devicefiles";

      return await axios
        .get(url, {
          crossDomain: true,
          withCredentials: false,
          // origin: true,
          auth: {
            username: "Tecnico",
            password: "Master"
          },
          headers: {
            "postman-token": "513705db-790d-ead9-bab6-7f1b682583c6",
            "cache-control": "no-cache",
            // "Access-Control-Allow-Origin": "*",
            "Content-type": "Application/json"
            // Authorization: "Basic VGVjbmljbzpNYXN0ZXI="
          },
          params: {
            deviceid: deviceId.Geraeteid,
            format: "JSON",
            apikey: "509-10350-6da36b49ef06ce650b8daa6edfe881de",
            providerid: deviceId.supplier.code
          }
        })

        .then(response => {
          console.log(response.data);
          this.files = response.data.files;
        }).catch(e => {
          console.log(e);
        })
    }
    function openfile(file) {
      this.dialog.show = true;
      this.fileurl = file;
      console.log(file);
      console.log(this.fileurl);

      // window.open(file, "_blank");
    }
    function getPartDetails(part) {
      usePartStore().setPart(part)
      router.push({ name: 'Part', params: { id: part.Artikelnummer } })
    }
    return {
      supplier: { name: String, code: String },
      getPartDetails,
      getALLParts,
      getSeviceNetParts,
      getAltParts,
      fileurl,
      newSearch,
      newPartSearch,
      search,
      searchPartNumber,
      searchPN,
      searchArticle,
      SparePartSearch,
      PosLookup,
      PartSearch,
      StockCheck,
      DeliveryTime,
      Obsolete,
      searchDeviceArticle,
      ArticleSearch,
      DeviceArticleSearch,
      DeviceFilesSearch,
      searchDeviceFiles,
      filterByCodeOrType,
      searchArticleReplacment,
      articleNo,
      Devices,
      files,
      lookingat,
      openfile,
      FilterButton,
      allpartsjson: json,
      name: "Search Aswo",
      props: {
        msg: String
      },
      PartsTable,
      dialog,
      getitemcontrols() {
        return `Artikelnummer`;
      }
    };
  }
};
</script>
 
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.w-app .primary--bg {
  background-color: #021d48;
}

h3 {
  margin: 40px 0 0;
}

ul {
  list-style-type: none;
  padding: 0;
}

li {
  display: inline-block;
  margin: 0 10px;
}

a {
  color: #42b983;
}

img {
  height: 50px;
  width: 50px;
}

.file {
  /* /* height: 150px; */
  width: 100%;
}
</style>
